export function assignRef<T>(targetRef: React.Ref<T>, value: T | null): void {
  if (typeof targetRef === 'function') {
    targetRef(value)
  } else if (targetRef) {
    ;(targetRef as { current: T | null }).current = value
  }
}
